<!-- eslint-disable -->
<template>
  <div class="page_box">
    <sb-headline title="拼团记录"></sb-headline>
    <my-table ref="list" :data="listData" @page="pageHandler" :listLoading="listLoading">
      <template #header="params">
        <div class="search_box">
          <el-row :gutter="10">
            <el-col :span="4">
              <div class="search_item">
                <div>活动ID：</div>
                <el-input v-model="searchData.activityId"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="search_item">
                <div>活动名称：</div>
                <el-input v-model="searchData.activityName"></el-input>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="search_item">
                <div>团长昵称：</div>
                <el-input v-model="searchData.nickName"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="search_item">
                <div>拼团状态：</div>
                <el-select v-model="searchData.status" placeholder="请选择" clearable>
                  <el-option label="拼团中" :value="1"></el-option>
                  <el-option label="拼团成功" :value="2"></el-option>
                  <el-option label="拼团失败" :value="3"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin-top: 10px;">
            <el-col :span="4" :offset="20" style="text-align: end;">
              <el-button @click="pageHandler(params, 1, 'reset')">重置</el-button>
              <el-button @click="pageHandler(params, 1)" type="primary">查询</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
      <el-table-column label="团队ID" fixed="left" prop="groupTeamId" :min-width="160"></el-table-column>
      <el-table-column label="活动名称" prop="activityName" :min-width="120"></el-table-column>
      <el-table-column label="拼团价格" prop="price" :min-width="120"></el-table-column>
      <el-table-column label="团长昵称" prop="nickName" :min-width="120"></el-table-column>
      <el-table-column label="当前人数/成团人数" prop="crowdName" :min-width="160">
        <template slot-scope="scope">
          <div>{{ scope.row.joinNum }}/{{ scope.row.groupNum }}</div>
        </template>
      </el-table-column>
      <el-table-column label="拼团状态" prop="statusStr" :min-width="120"></el-table-column>
      <el-table-column label="开团时间" prop="" :min-width="220">
        <template slot-scope="scope">
          <div>开始时间：{{ scope.row.startTime }}</div>
          <div>结束时间：{{ scope.row.endTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" prop="" width="120">
        <template slot-scope="scope">
          <el-button class="handle_btn" type="text" size="mini" @click="tableHandle(1, scope.row)">查看</el-button>
          <el-button class="handle_btn" type="text" size="mini" @click="tableHandle(2, scope.row)" v-if="scope.row.status == 1">立即成团</el-button>
        </template>
      </el-table-column>
    </my-table>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
    data() {
    //这里存放数据
      return {
        listData: [{},{},{}],
        // 搜索数据
        searchData: {
          activityId: "",
          activityName: "",           //活动名称
          nickName: "",               //团长昵称
          status: "",                 //拼团状态
        },
        listLoading: false, //列表loading        rewardDialogVisible: false,
      };
    },
  filters: {
    stateFilter: function(val) {
      
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    pageHandler(params, num, type) {
      if(type == 'reset'){
        this.resetSearchData();
      }
      this.getActivityList(params, num ? num : params.pageNum, params.pageSize);
    },
    // 表格内操作
    tableHandle(type, row) {
      switch (type) {
        case 1:     //查看
          this.$router.push(`/management/groupBuying/groupOrder/detail?id=${row.groupTeamId}`);
          break;

        case 2: //立即成团
          this.$confirm('是否立即成团?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch('management/rightTeamSuccess',{//groupActivityList
              groupTeamId: row.groupTeamId
            }).then(res => {
              if(res.code == 0){
                this.$refs.list.init();
                this.$message.success('操作成功')
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消操作'
            });
          })

          break
        default:
          break;
      }
    },

    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {
        activityId: "",
        activityName: "",           //活动名称
        nickName: "",               //团长昵称
        status: "",                 //拼团状态
      }
    },

    // 获取拼团订单列表
    getActivityList(params,pageNum,pageSize) {
      this.listLoading = true;
      this.$store.dispatch('management/groupOrderList',{// groupOrderList
        ...this.searchData,
        pageNum,
        pageSize,
      }).then(res => {
        if(res.code == 0){
          this.listData = res.data.list;
          params.render(res.data.total);
        }
        this.listLoading = false;
      })
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.query.activityId) {
      this.searchData.activityId = this.$route.query.activityId;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
  //@import url(); 引入公共css类
  .page_box {
    padding: 0 20px;
    .search_box {
      background: #fff;
      padding: 20px;
      margin-top: 20px;
    }
    .table_nav_bar{
      width: 100%;
      background: #fff;
      padding: 20px 20px 0 20px;
      box-sizing: border-box;
      .el-button{
        margin-right: 10px;
      }
    }
    .table_row_rule{
      word-break: break-all; /** 换行，长单词会分成两行显示 **/
      text-overflow: ellipsis;/** 隐藏文本省略号 ... **/
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 1; /** 显示的行数 **/
      overflow: hidden;  /** 隐藏超出的内容 **/;
    }
  }
  .handle_btn{
    padding: 0;
  }
  .channel_item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    >.el-input:nth-child(1){
      width: 260px;
    }
  }
  .channel_item:last-child{
    margin: 0;
  }
  .popularize_list_qrcode{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .qrcode_img_src{
    position: absolute;
    top: -10000%;
    z-index: -10000;
  }
  .search_item{
    display: flex;
    align-items: center;
    >div:first-child{
      flex-shrink: 0;
    }
  }
  ::v-deep .el-table__header thead tr th:first-of-type, .el-table__body tbody tr td:first-of-type{
    padding: 0 !important;
  }
  ::v-deep .el-table__body tbody tr td:first-of-type {
    padding-left: 0px !important;
  }
</style>
